import { createReducer, on } from '@ngrx/store';
import { seSignInitialState } from './estensasign.state';
import { seSignOtpSmsError, seSignOtpSmsRequest, seSignOtpSmsReset, seSignOtpSmsSuccess } from './estensasign.actions';

export const seSignReducer = createReducer(
    seSignInitialState,
    on(seSignOtpSmsReset, (state) => ({ ...state, otpSms: null })),
    on(seSignOtpSmsRequest, (state) => ({ ...state, otpSms: 'loading' as const })),
    on(seSignOtpSmsSuccess, (state) => ({ ...state, otpSms: 'success' as const })),
    on(seSignOtpSmsError, (state, { message: error }) => ({ ...state, otpSms: { error } as const })),
);
